import { useEffect } from 'react';

import {
  useCurrentCustomerId,
  useCurrentWorkspaceId,
  useProjectActions,
} from 'src/store';
import { useErrorHandler } from '../hooks/useErrorHandler';

export const useRefreshUsedProjectTypes = () => {
  const projectActions = useProjectActions();
  const handleError = useErrorHandler();

  const currentCustomerId = useCurrentCustomerId();
  const currentWorkspaceId = useCurrentWorkspaceId();

  // Load project types already used by customer
  useEffect(() => {
    if (!currentCustomerId) {
      return;
    }

    projectActions
      .queryUsedProjectTypes(currentCustomerId, currentWorkspaceId)
      .catch((error) => {
        handleError(error);
      });
  }, [projectActions, currentCustomerId, currentWorkspaceId, handleError]);
};
